module.exports = __webpack_public_path__ + "static/img/google-play-badge.3f3e3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-badge.png
// module id = Ya6b
// module chunks = 25